import api from './api';

export const getBudgetMonths = () => api.get('/budget/months');
export const getBudgetYears = () => api.get('/budget/years');
export const getBudgetForMonth = (month) => api.get(`/budget/${month}`);
export const getBudgetAverage = (year) =>
  api.get('/budget/average', { params: { year } });
export const updateBudgetItem = (month, data) =>
  api.put(`/budget/${month}/item`, data);
export const acceptMissingFlag = (data) =>
  api.post('/budget/average/accept', data);
export const acceptAllMissingFlags = (data) =>
  api.post('/budget/average/accept-all', data);
export const removeAcceptance = (id) =>
  api.delete(`/budget/average/accept/${id}`);
export const getValidationForMonth = (month, showResolved = false) =>
  api.get(`/budget/${month}/validation`, { params: { show_resolved: showResolved } });
export const resolveFlag = (flagId, notes = '') =>
  api.post(`/budget/validation/${flagId}/resolve`, { notes });
export const getTypoCheck = (year) =>
  api.get('/budget/typo-check', { params: { year } });
